var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-wizard-button',{attrs:{"disabled":_vm.disabled || _vm.bookmarks.length === 0},on:{"click":_vm.generate}},[_vm._t("default",function(){return [_vm._v("QR-Codes exportieren")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }